import { useEffect, useState } from 'react'

type FavoritesErrorDialogInput = {
  isFavorites: boolean
  isPhotosError: boolean
  isPhotosLoading: boolean
  albumPhotoCount: number
}

/** Opens the "Unable to load My Favorites" dialog when the Favorites album fails to load. */
export function useFavoritesErrorDialog({
  isFavorites,
  isPhotosError,
  isPhotosLoading,
  albumPhotoCount,
}: FavoritesErrorDialogInput) {
  const [favoritesErrorOpen, setFavoritesErrorOpen] = useState(false)

  useEffect(() => {
    if (isFavorites && isPhotosError && !isPhotosLoading && albumPhotoCount === 0) {
      setFavoritesErrorOpen(true)
      return
    }

    if (!isPhotosError) {
      setFavoritesErrorOpen(false)
    }
  }, [albumPhotoCount, isFavorites, isPhotosError, isPhotosLoading])

  return [favoritesErrorOpen, setFavoritesErrorOpen] as const
}
